.ba{position:absolute;}